import React, { ComponentProps, useEffect, useState } from "react";
import * as S from "./styles";

interface ISwitchOptionsValuesProps {
  Icon?: string;
  value: any;
  label: string;
}

interface ISwitchOptionsProps extends ComponentProps<"div"> {
  options: ISwitchOptionsValuesProps[];
  handleOnChange: (s: string) => void;
  disabled?: boolean;
  value: string;
}

export const SwitchOptions = ({
  handleOnChange,
  options,
  disabled,
  value,
  ...rest
}: ISwitchOptionsProps) => {
  const name = `${new Date()} - ${Math.random()}`;

  return (
    <S.Container {...rest}>
      {options.map((option, index) => (
        <S.Label key={index} data-disabled={disabled}>
          <S.WrapperContent>
            {option.Icon && (
              <img
                className="icon"
                src={option.Icon}
                alt={`Icone ${option.label}`}
              />
            )}
            {option.label}
            <S.Input
              name={name}
              type="radio"
              disabled={disabled}
              checked={option.value === value}
              onChange={() => handleOnChange(option.value)}
            />
          </S.WrapperContent>
        </S.Label>
      ))}
    </S.Container>
  );
};
